import { Box, Typography } from "@mui/material";
import React from "react";

function PageHeader({ title, top, subtitle, action, justify }) {
  if (!title && !top && !subtitle && !action) return null;

  const defaultJustify = title ? "space-between" : "flex-end";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "flex-start", md: "center" },
        justifyContent: justify || defaultJustify,
        gap: 2,
        mb: 3,
      }}
    >
      {(title || top || subtitle) && (
        <Box sx={{ minWidth: 0 }}>
          {top && <Box sx={{ mb: 0.75 }}>{top}</Box>}
          {title && <Typography variant="h4">{title}</Typography>}
          {subtitle && <Box sx={{ mt: 0.75 }}>{subtitle}</Box>}
        </Box>
      )}
      {action && (
        <Box sx={{ flexShrink: 0, width: { xs: "100%", md: "auto" } }}>
          {action}
        </Box>
      )}
    </Box>
  );
}

export default PageHeader;
